(function(){
  'use strict';
  if (window.__ES_TRYON_CLEAN_LOADED__) return;
  window.__ES_TRYON_CLEAN_LOADED__ = true;

  var state = {
    modal:null, canvas:null, ctx:null, video:null, stream:null,
    frame:null, frameProcessed:null, frameReady:false, frameUrl:'', photo:null, photoOriginal:null,
    frameChoices:[], frameChoiceIndex:0, frameCache:{}, frameDepthCache:{}, frameRenderCache:{},
    bodyScrollY:0, bodyScrollLocked:false,
    calibrationActive:false, calibrationReview:false, pupilClicks:[], pupilDragIndex:null, pupilDragActive:false, pupilDragPoint:null, calibratedPupils:null, originalPupils:null, calibrationBase:null, calibrationBackup:null, calibrationWasExisting:false,
    frameAnchorYRatio:0.5, frameWidthMm:140, frameVerticalOffsetMm:3,
    scale:0.56, suggestedScale:0.56, rot:0, x:0, y:0, dragging:false, dragStart:null,
    drawRaf:0, resizeRaf:0, activeOpener:null, photoBgKey:'', photoBgDataUrl:'',
    photoLighting:105
  };

  var TRYON_STORAGE_KEY = 'eyeshells_tryon_local_photo_v3';
  var TRYON_LEGACY_STORAGE_KEYS = ['eyeshells_tryon_local_photo_v2'];
  var TRYON_STORAGE_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setStatus(msg){ var el = state.modal && qs('[data-es-tryon-clean-status]', state.modal); if (el) el.textContent = msg || ''; }

  function clampPhotoLighting(value){
    var num = parseFloat(value);
    if (!isFinite(num)) num = 105;
    return Math.max(90, Math.min(120, Math.round(num)));
  }

  function getPhotoLightingValue(){
    if (!state.modal) return clampPhotoLighting(state.photoLighting);
    var input = qs('[data-es-tryon-clean-lighting]', state.modal);
    if (!input) return clampPhotoLighting(state.photoLighting);
    state.photoLighting = clampPhotoLighting(input.value);
    return state.photoLighting;
  }

  function getPhotoLightingFilter(){
    var value = getPhotoLightingValue();
    var brightness = value / 100;
    var contrast = Math.max(.98, Math.min(1.08, 1 + (brightness - 1) * .45));
    var saturate = Math.max(.96, Math.min(1.04, 1 + (brightness - 1) * .12));
    return 'brightness(' + brightness.toFixed(3) + ') contrast(' + contrast.toFixed(3) + ') saturate(' + saturate.toFixed(3) + ')';
  }

  function drawPhotoOnly(ctx, source, dx, dy, dw, dh){
    if (!ctx || !source) return;
    ctx.save();
    try { ctx.filter = getPhotoLightingFilter(); } catch(err) {}
    ctx.drawImage(source, dx, dy, dw, dh);
    ctx.restore();
  }

  function updatePhotoLightingUI(){
    if (!state.modal) return;
    var input = qs('[data-es-tryon-clean-lighting]', state.modal);
    if (!input) return;
    input.value = String(clampPhotoLighting(state.photoLighting));
    var value = clampPhotoLighting(input.value);
    var label = 'Auto photo lighting';
    if (value < 102) label = 'Darker photo lighting';
    else if (value > 108) label = 'Brighter photo lighting';
    input.setAttribute('aria-valuetext', label);
  }

  function setPhotoLighting(value, shouldPersist){
    state.photoLighting = clampPhotoLighting(value);
    updatePhotoLightingUI();
    updatePhotoBackground();
    requestDraw();
    if (shouldPersist && state.photo) persistTryOnSession();
  }

  function closePdHelp(){
    if (!state.modal) return;
    qsa('[data-es-tryon-clean-pd-help]', state.modal).forEach(function(wrap){
      wrap.classList.remove('is-open');
      var btn = qs('[data-es-tryon-clean-pd-help-btn]', wrap);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function togglePdHelp(wrap, forceOpen){
    if (!wrap) return;
    var shouldOpen = forceOpen;
    if (typeof shouldOpen !== 'boolean') shouldOpen = !wrap.classList.contains('is-open');
    closePdHelp();
    if (shouldOpen) {
      wrap.classList.add('is-open');
      var btn = qs('[data-es-tryon-clean-pd-help-btn]', wrap);
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
  }

  function resetPupilMarkingState(){
    state.calibrationActive = false;
    state.calibrationReview = false;
    state.pupilClicks = [];
    state.pupilDragIndex = null;
    state.pupilDragActive = false;
    state.pupilDragPoint = null;
    state.calibrationBase = null;
    state.calibrationBackup = null;
    state.calibrationWasExisting = false;
    if (state.modal) state.modal.classList.remove('is-calibrating','is-pupil-review');
  }

  function safeStorageGet(){
    try { return window.localStorage ? window.localStorage.getItem(TRYON_STORAGE_KEY) : null; } catch(err) { return null; }
  }

  function safeStorageSet(value){
    try {
      if (!window.localStorage) return false;
      window.localStorage.setItem(TRYON_STORAGE_KEY, value);
      return true;
    } catch(err) { return false; }
  }

  function safeStorageRemove(){
    try {
      if (!window.localStorage) return;
      window.localStorage.removeItem(TRYON_STORAGE_KEY);
      (TRYON_LEGACY_STORAGE_KEYS || []).forEach(function(key){ try { window.localStorage.removeItem(key); } catch(err) {} });
    } catch(err) {}
  }

  function safeStorageGetKey(key){
    try { return window.localStorage ? window.localStorage.getItem(key) : null; } catch(err) { return null; }
  }

  function readStoredTryOnData(){
    var raw = safeStorageGet();
    if (raw) {
      try {
        var data = JSON.parse(raw);
        if (!data || data.version !== 3 || !data.updatedAt || !data.originalDataUrl) return null;
        if (Date.now() - data.updatedAt > TRYON_STORAGE_MAX_AGE) { safeStorageRemove(); return null; }
        return data;
      } catch(err) { return null; }
    }

    // 1131: migrate legacy local photo data safely. Older versions stored the leveled/canvas
    // preview image and fit state; that can reopen as a tiny photo after theme changes. Keep
    // only the original uploaded photo and PD, then ask the shopper to set pupils again.
    for (var i = 0; i < (TRYON_LEGACY_STORAGE_KEYS || []).length; i++) {
      var legacyRaw = safeStorageGetKey(TRYON_LEGACY_STORAGE_KEYS[i]);
      if (!legacyRaw) continue;
      try {
        var legacy = JSON.parse(legacyRaw);
        if (!legacy || !legacy.updatedAt || !legacy.originalDataUrl) continue;
        if (Date.now() - legacy.updatedAt > TRYON_STORAGE_MAX_AGE) continue;
        return { version:3, migrated:true, updatedAt:legacy.updatedAt, originalDataUrl:legacy.originalDataUrl, pd:legacy.pd || null };
      } catch(err2) {}
    }
    return null;
  }

  function sourceSize(source){
    return { w: Math.max(1, source && (source.naturalWidth || source.width) || 1), h: Math.max(1, source && (source.naturalHeight || source.height) || 1) };
  }

  function imageToStoredJpeg(source, maxSize, quality){
    if (!source) return null;
    try {
      var size = sourceSize(source);
      var ratio = Math.min(1, (maxSize || 1400) / Math.max(size.w, size.h));
      var w = Math.max(1, Math.round(size.w * ratio));
      var h = Math.max(1, Math.round(size.h * ratio));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0,0,w,h);
      ctx.drawImage(source, 0, 0, w, h);
      return { dataUrl:c.toDataURL('image/jpeg', quality || 0.86), width:w, height:h, sx:w/size.w, sy:h/size.h };
    } catch(err) { return null; }
  }

  function scalePupilsForStoredPhoto(pupils, stored){
    if (!pupils || !stored) return null;
    return {
      left:{ x:pupils.left.x * stored.sx, y:pupils.left.y * stored.sy },
      right:{ x:pupils.right.x * stored.sx, y:pupils.right.y * stored.sy },
      angleDeg:pupils.angleDeg || 0
    };
  }

  function getPdSettings(){
    if (!state.modal) return null;
    var single = qs('[data-es-tryon-clean-pd-single]', state.modal);
    var right = qs('[data-es-tryon-clean-pd-right]', state.modal);
    var left = qs('[data-es-tryon-clean-pd-left]', state.modal);
    return {
      dual: isDualPdMode(),
      single: single ? single.value : '',
      right: right ? right.value : '',
      left: left ? left.value : ''
    };
  }

  function applyPdSettings(settings){
    if (!state.modal || !settings) return;
    var mode = qs('[data-es-tryon-clean-pd-mode]', state.modal);
    var single = qs('[data-es-tryon-clean-pd-single]', state.modal);
    var right = qs('[data-es-tryon-clean-pd-right]', state.modal);
    var left = qs('[data-es-tryon-clean-pd-left]', state.modal);
    if (mode) mode.checked = !!settings.dual;
    if (single && settings.single !== undefined) single.value = settings.single || '';
    if (right && settings.right !== undefined) right.value = settings.right || '';
    if (left && settings.left !== undefined) left.value = settings.left || '';
    updatePdModeUI();
    updateSizeBasisText();
  }

  function updateSavedPhotoUI(){
    if (!state.modal) return;
    var hasPhoto = !!(state.photo || readStoredTryOnData());
    qsa('[data-es-tryon-clean-clear-photo]', state.modal).forEach(function(clearBtn){ clearBtn.hidden = !hasPhoto; });
  }

  function updatePhotoBackground(){
    if (!state.modal) return;
    var bg = qs('[data-es-tryon-clean-photo-bg]', state.modal);
    if (!bg) return;
    if (!state.photo) {
      bg.hidden = true;
      bg.style.backgroundImage = '';
      bg.style.removeProperty('--es-tryon-photo-lighting-filter');
      state.photoBgKey = '';
      state.photoBgDataUrl = '';
      return;
    }
    var size = sourceSize(state.photo);
    var key = (state.photo.src || '') + '|' + size.w + 'x' + size.h;
    if (state.photoBgKey !== key) {
      var stored = imageToStoredJpeg(state.photo, 900, 0.52);
      state.photoBgDataUrl = stored && stored.dataUrl ? stored.dataUrl : (state.photo.src || '');
      state.photoBgKey = key;
    }
    bg.style.setProperty('--es-tryon-photo-lighting-filter', getPhotoLightingFilter());
    if (state.photoBgDataUrl) {
      bg.style.backgroundImage = 'url("' + String(state.photoBgDataUrl).replace(/"/g, '\\"') + '")';
      bg.hidden = false;
    } else {
      bg.hidden = true;
      bg.style.backgroundImage = '';
    }
  }

  function loadImageFromDataUrl(dataUrl){
    return new Promise(function(resolve, reject){
      if (!dataUrl) { reject(new Error('missing image')); return; }
      var img = new Image();
      img.onload = function(){ resolve(img); };
      img.onerror = reject;
      img.src = dataUrl;
    });
  }

  function persistTryOnSession(){
    if (!state.photoOriginal && !state.photo) return false;
    var original = imageToStoredJpeg(state.photoOriginal || state.photo, 1400, 0.86);
    if (!original) return false;
    var data = { version:3, updatedAt:Date.now(), originalDataUrl:original.dataUrl, pd:getPdSettings(), photoLighting:clampPhotoLighting(state.photoLighting) };
    if (state.originalPupils) {
      data.originalPupils = scalePupilsForStoredPhoto(state.originalPupils, original);
    }
    var ok = safeStorageSet(JSON.stringify(data));
    updateSavedPhotoUI();
    if (!ok) setStatus('Photo is ready for this page. Browser storage is full, so it may not carry to other frames.');
    return ok;
  }

  function restoreTryOnSession(){
    return new Promise(function(resolve){
      if (state.photo) { updateSavedPhotoUI(); resolve(false); return; }
      var data = readStoredTryOnData();
      if (!data) { updateSavedPhotoUI(); resolve(false); return; }
      Promise.all([
        loadImageFromDataUrl(data.originalDataUrl)
      ]).then(function(items){
        state.photoOriginal = items[0];
        state.photo = items[0];
        state.photoLighting = clampPhotoLighting(data.photoLighting);
        updatePhotoLightingUI();
        state.originalPupils = data.originalPupils ? copyPupils(data.originalPupils) : null;
        state.calibratedPupils = null;
        if (state.originalPupils && state.originalPupils.left && state.originalPupils.right) {
          var a = Math.atan2(state.originalPupils.right.y - state.originalPupils.left.y, state.originalPupils.right.x - state.originalPupils.left.x);
          var corrected = buildLeveledPhoto(state.photoOriginal, state.originalPupils.left, state.originalPupils.right, a);
          if (corrected) {
            state.photo = corrected.canvas;
            state.calibratedPupils = { left:corrected.left, right:corrected.right, angleDeg:a * 180 / Math.PI };
          } else {
            state.originalPupils = null;
          }
        }
        state.pupilClicks = [];
        state.calibrationActive = false;
        state.calibrationReview = false;
        state.pupilDragIndex = null;
        state.pupilDragActive = false;
        state.pupilDragPoint = null;
        state.calibrationBase = null;
        state.calibrationBackup = null;
        applyPdSettings(data.pd);
        updateMarkButton();
        // 1137: do not reveal the restored canvas before the modal/stage has a real size.
        // The caller will show photo mode and resize the canvas in the correct order.
        updateSavedPhotoUI();
        resolve(true);
      }).catch(function(){
        safeStorageRemove();
        updateSavedPhotoUI();
        resolve(false);
      });
    });
  }

  function clearTryOnPhoto(){
    safeStorageRemove();
    stopCamera();
    state.photo = null;
    state.photoOriginal = null;
    state.photoBgKey = '';
    state.photoBgDataUrl = '';
    state.photoLighting = 105;
    updatePhotoLightingUI();
    state.calibratedPupils = null;
    state.originalPupils = null;
    resetPupilMarkingState();
    updateMarkButton();
    updatePupilReviewUI();
    setPupilStep(null);
    updateSavedPhotoUI();
    showEmptyMode('Saved try-on photo cleared. Upload a new photo to start.');
  }

  function getMainImageUrl(opener){
    var url = '';
    var img = qs('.product-single__photo img, .product-photo-container img, .product-gallery img, img.engoj_img_main, .product-image-main img, .product__media img, .product-single__media img');
    if (img) url = img.currentSrc || img.src || img.getAttribute('data-src') || img.getAttribute('data-zoom-image') || '';
    if (!url && opener) url = opener.getAttribute('data-es-tryon-frame') || '';
    if (url && url.indexOf('//') === 0) url = window.location.protocol + url;
    return url;
  }


  function normalizeImageUrl(url){
    if (!url) return '';
    return String(url).replace(/^https?:/, '').replace(/^\/\//, '').replace(/\?.*$/, '').replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-zA-Z]+(?:$|\?))/, '');
  }

  function imageUrlAtSize(url, size){
    if (!url) return '';
    url = String(url).trim();
    if (url.indexOf('//') === 0) url = window.location.protocol + url;
    return url.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-zA-Z]+(?:$|\?))/, '_' + size);
  }

  function extractCssUrl(value){
    if (!value) return '';
    var m = String(value).match(/url\((['"]?)(.*?)\1\)/i);
    return m && m[2] ? m[2] : '';
  }

  function getSelectedColorLabel(){
    var checked = qs('.es-swatch--color [data-value] input[type="radio"]:checked');
    var node = checked && checked.closest ? checked.closest('[data-value]') : null;
    return node ? (node.getAttribute('data-value') || '').trim() : '';
  }

  function parseLiquidFrameData(opener){
    var root = opener && opener.closest ? opener.closest('form') : null;
    var dataEl = root ? qs('[data-es-tryon-frame-data]', root) : qs('[data-es-tryon-frame-data]');
    if (!dataEl) return [];
    try {
      var parsed = JSON.parse(dataEl.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter(function(item){ return item && item.url; }) : [];
    } catch(err) {
      return [];
    }
  }

  function normalizeMmValue(value){
    var n = parseFloat(String(value || '').replace(',', '.'));
    if (!isFinite(n)) return NaN;
    return (n >= 80 && n <= 220) ? n : NaN;
  }

  function normalizeVerticalOffsetMm(value){
    var n = parseFloat(String(value || '').replace(',', '.'));
    if (!isFinite(n)) return NaN;
    // Positive values place the frame's visual center below the pupil line; negative values are allowed for special frames.
    return (n >= -12 && n <= 18) ? n : NaN;
  }

  function parseFrameWidthMmFromText(text, labelRequired){
    if (!text) return NaN;
    var s = String(text).replace(/\s+/g, ' ');
    var m = s.match(/(?:frame\s*width|total\s*frame\s*width|overall\s*frame\s*width)[^0-9]{0,60}(\d{2,3}(?:[.,]\d+)?)\s*(?:mm|毫米)/i);
    if (!m && !labelRequired) m = s.match(/(\d{2,3}(?:[.,]\d+)?)\s*(?:mm|毫米)/i);
    if (!m) return NaN;
    return normalizeMmValue(m[1]);
  }

  function getTryOnFrameWidthMm(opener){
    var attrNames = ['data-es-tryon-frame-width', 'data-es-frame-width', 'data-frame-width', 'data-frame-width-mm'];
    for (var ai = 0; opener && ai < attrNames.length; ai++) {
      var fromAttr = normalizeMmValue(opener.getAttribute(attrNames[ai]));
      if (isFinite(fromAttr)) return fromAttr;
    }

    var active = getActiveFrameChoice ? getActiveFrameChoice() : null;
    var activeVal = active && (active.frame_width || active.frameWidth || active.frame_width_mm || active.frameWidthMm || '');
    activeVal = normalizeMmValue(activeVal);
    if (isFinite(activeVal)) return activeVal;

    var roots = [];
    if (opener && opener.closest) {
      var form = opener.closest('form');
      var pdp = opener.closest('.product, .product-single, .product-detail, .product-detail-wrapper, .product-page, .template-product');
      if (form) roots.push(form);
      if (pdp && roots.indexOf(pdp) < 0) roots.push(pdp);
    }
    roots.push(document);

    var selectors = [
      '[data-es-frame-width]', '[data-frame-width]', '[data-frame-width-mm]',
      'li.frame-width', '.frame-width', '.es-frame-width', '[class*=\"frame-width\"]'
    ];
    for (var ri = 0; ri < roots.length; ri++) {
      var root = roots[ri];
      for (var si = 0; si < selectors.length; si++) {
        var nodes = qsa(selectors[si], root);
        for (var ni = 0; ni < nodes.length; ni++) {
          var node = nodes[ni];
          var attrVal = normalizeMmValue(node.getAttribute && (node.getAttribute('data-es-frame-width') || node.getAttribute('data-frame-width') || node.getAttribute('data-frame-width-mm')));
          if (isFinite(attrVal)) return attrVal;
          var loose = parseFrameWidthMmFromText(node.textContent || '', false);
          if (isFinite(loose)) return loose;
        }
      }
    }

    var bodyText = document.body ? document.body.textContent : '';
    var labeled = parseFrameWidthMmFromText(bodyText, true);
    if (isFinite(labeled)) return labeled;
    return 140;
  }

  function getTryOnVerticalOffsetMm(opener){
    var attrNames = ['data-es-tryon-vertical-offset', 'data-es-tryon-vertical-offset-mm', 'data-tryon-vertical-offset-mm'];
    for (var ai = 0; opener && ai < attrNames.length; ai++) {
      var fromAttr = normalizeVerticalOffsetMm(opener.getAttribute(attrNames[ai]));
      if (isFinite(fromAttr)) return fromAttr;
    }
    var active = getActiveFrameChoice ? getActiveFrameChoice() : null;
    var activeVal = active && (active.vertical_offset_mm || active.verticalOffsetMm || active.vertical_offset || active.verticalOffset || '');
    activeVal = normalizeVerticalOffsetMm(activeVal);
    if (isFinite(activeVal)) return activeVal;
    return 3;
  }

  function collectFrameChoices(opener){
    var liquidItems = parseLiquidFrameData(opener);
    var selectedLabel = getSelectedColorLabel();
    var currentNorm = normalizeImageUrl(getMainImageUrl(opener));
    if (liquidItems.length) {
      var itemsFromLiquid = [];
      var seenLiquid = {};
      var selectedLiquidIndex = -1;
      liquidItems.forEach(function(item){
        var labelText = (item.label || '').trim();
        var rawUrl = item.source === 'metafield' ? item.url : imageUrlAtSize(item.url, '900x');
        if (!rawUrl) return;
        if (rawUrl.indexOf('//') === 0) rawUrl = window.location.protocol + rawUrl;
        var key = (labelText + '|' + normalizeImageUrl(rawUrl)).toLowerCase();
        if (seenLiquid[key]) return;
        seenLiquid[key] = true;
        var cleanItem = {
          label: labelText || ('Color ' + (itemsFromLiquid.length + 1)),
          url: rawUrl,
          source: item.source || 'variant',
          variant_id: item.variant_id || '',
          anchor_y: item.anchor_y || item.anchorY || item.anchor || '',
          frame_width: item.frame_width || item.frameWidth || item.frame_width_mm || item.frameWidthMm || '',
          vertical_offset_mm: item.vertical_offset_mm || item.verticalOffsetMm || item.vertical_offset || item.verticalOffset || '',
          depth_mode: item.depth_mode || item.depthMode || item.tryon_depth_mode || item.tryonDepthMode || item.depth || '',
          frame_type: item.frame_type || item.frameType || item.tryon_frame_type || item.tryonFrameType || '',
          perspective_yaw: item.perspective_yaw || item.perspectiveYaw || item.tryon_perspective_yaw || item.tryonPerspectiveYaw || ''
        };
        itemsFromLiquid.push(cleanItem);
        if (selectedLabel && cleanItem.label.toLowerCase() === selectedLabel.toLowerCase()) selectedLiquidIndex = itemsFromLiquid.length - 1;
      });
      if (selectedLiquidIndex < 0 && currentNorm) {
        itemsFromLiquid.forEach(function(item, idx){ if (normalizeImageUrl(item.url) === currentNorm) selectedLiquidIndex = idx; });
      }
      if (itemsFromLiquid.length) {
        if (selectedLiquidIndex < 0) selectedLiquidIndex = 0;
        return { items: itemsFromLiquid, index: selectedLiquidIndex };
      }
    }

    var items = [];
    var seen = {};
    var selectedIndex = -1;
    var nodes = qsa('.es-swatch--color [data-value]');
    nodes.forEach(function(node){
      var labelText = (node.getAttribute('data-value') || '').trim();
      var labelEl = qs('.color_style2', node);
      var rawUrl = labelEl ? extractCssUrl((window.getComputedStyle(labelEl).backgroundImage || labelEl.style.backgroundImage || '')) : '';
      rawUrl = imageUrlAtSize(rawUrl, '900x');
      if (!rawUrl) return;
      var key = (labelText + '|' + normalizeImageUrl(rawUrl)).toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      items.push({ label: labelText || ('Color ' + (items.length + 1)), url: rawUrl, source: 'swatch', depth_mode:'', frame_type:'', perspective_yaw:'' });
      if (qs('input[type="radio"]:checked', node)) selectedIndex = items.length - 1;
    });
    if (selectedIndex < 0 && currentNorm) {
      items.forEach(function(item, idx){ if (normalizeImageUrl(item.url) === currentNorm) selectedIndex = idx; });
    }
    if (!items.length) {
      var fallback = getMainImageUrl(opener);
      if (fallback) items.push({ label: 'Current color', url: fallback, source: 'product', depth_mode:'', frame_type:'', perspective_yaw:'' });
    }
    if (selectedIndex < 0) selectedIndex = 0;
    return { items: items, index: selectedIndex };
  }

  function getActiveFrameChoice(){
    return state.frameChoices && state.frameChoices.length ? state.frameChoices[state.frameChoiceIndex] : null;
  }

  function updateColorNav(){
    if (!state.modal) return;
    var nav = qs('[data-es-tryon-clean-color-nav]', state.modal);
    var name = qs('[data-es-tryon-clean-color-name]', state.modal);
    var prev = qs('[data-es-tryon-clean-prev-color]', state.modal);
    var next = qs('[data-es-tryon-clean-next-color]', state.modal);
    var count = state.frameChoices ? state.frameChoices.length : 0;
    if (nav) nav.hidden = count <= 1;
    var active = getActiveFrameChoice();
    if (name) name.textContent = active && active.label ? active.label : 'Current color';
    if (prev) prev.disabled = count <= 1 || state.frameChoiceIndex <= 0;
    if (next) next.disabled = count <= 1 || state.frameChoiceIndex >= count - 1;
  }

  function switchFrameChoice(step){
    if (!state.frameChoices || state.frameChoices.length <= 1) return;
    var nextIndex = Math.max(0, Math.min(state.frameChoices.length - 1, state.frameChoiceIndex + step));
    if (nextIndex === state.frameChoiceIndex) return;
    state.frameChoiceIndex = nextIndex;
    updateColorNav();
    updateSizeBasisText();
    var active = getActiveFrameChoice();
    if (!active || !active.url) return;
    state.frameUrl = active.url;
    qsa('[data-es-tryon-clean-prev-color],[data-es-tryon-clean-next-color]', state.modal).forEach(function(btn){ try{ btn.blur(); }catch(err){} });
    loadFrame(active.url, active).then(function(){
      if (state.calibratedPupils) applyFitFromPupils(true);
      draw();
    }).catch(function(){
      setStatus('Could not load this color preview.');
    });
  }


  function buildPdSelectOptions(min, max, step, placeholder){
    var html = '<option value="">' + (placeholder || 'Choose') + '</option>';
    min = Math.max(0.5, Number(min) || 0.5);
    max = Math.max(min, Number(max) || min);
    step = Math.max(0.5, Number(step) || 0.5);
    var n = Math.round((max - min) / step);
    for (var i = 0; i <= n; i++) {
      var val = Math.round((min + i * step) * 10) / 10;
      if (!isFinite(val) || val <= 0) continue;
      var label = (Math.abs(val - Math.round(val)) < 0.001) ? String(Math.round(val)) : val.toFixed(1);
      html += '<option value="' + label + '">' + label + '</option>';
    }
    return html;
  }

  function buildModal(){
    if (state.modal) return state.modal;
    var singlePdOptions = buildPdSelectOptions(40, 80, 1, 'Choose');
    var dualRightPdOptions = buildPdSelectOptions(20, 40, 0.5, 'Right');
    var dualLeftPdOptions = buildPdSelectOptions(20, 40, 0.5, 'Left');
    var pdHelpHtml = '<span class="es-tryon-clean__pd-help" data-es-tryon-clean-pd-help>'+ 
      '<button type="button" class="es-tryon-clean__pd-help-btn" data-es-tryon-clean-pd-help-btn aria-label="What is PD?" aria-expanded="false">i</button>'+ 
      '<span class="es-tryon-clean__pd-popover" role="tooltip">'+ 
        '<button type="button" class="es-tryon-clean__pd-popover-close" data-es-tryon-clean-pd-help-close aria-label="Close PD help">×</button>'+ 
        '<strong>Pupillary Distance (PD)</strong>'+ 
        '<span>PD is the distance between the centers of your pupils, measured in millimeters.</span>'+ 
        '<span>Average adult PD is about 63mm, but it varies by person.</span>'+ 
        '<svg class="es-tryon-clean__pd-diagram" viewBox="0 0 190 72" aria-hidden="true" focusable="false">'+ 
          '<path d="M31 46c14-16 28-16 42 0"/>'+ 
          '<path d="M117 46c14-16 28-16 42 0"/>'+ 
          '<circle cx="52" cy="45" r="7"/>'+ 
          '<circle cx="138" cy="45" r="7"/>'+ 
          '<path class="es-tryon-clean__pd-arrow" d="M52 22h86"/>'+ 
          '<path class="es-tryon-clean__pd-tick" d="M52 17v10M138 17v10"/>'+ 
          '<text x="95" y="15" text-anchor="middle">PD</text>'+ 
        '</svg>'+ 
      '</span>'+ 
    '</span>';
    var frameColorHelpHtml = '<span class="es-tryon-clean__pd-help es-tryon-clean__color-help" data-es-tryon-clean-pd-help>'+
      '<button type="button" class="es-tryon-clean__pd-help-btn es-tryon-clean__color-help-btn" data-es-tryon-clean-pd-help-btn aria-label="Frame color note" aria-expanded="false">!</button>'+
      '<span class="es-tryon-clean__pd-popover es-tryon-clean__color-popover" role="tooltip">'+
        '<button type="button" class="es-tryon-clean__pd-popover-close" data-es-tryon-clean-pd-help-close aria-label="Close frame color note">×</button>'+
        '<strong>Frame Color Note</strong>'+
        '<span>Frame photos are taken under bright studio lighting to show shape, color, and material details clearly.</span>'+
        '<span>In virtual try-on, some colors may look brighter or higher-contrast on screen, especially with indoor or low-light selfies.</span>'+
        '<span>The actual frame color may appear a little deeper and more natural in everyday lighting. Please also check the product photos before ordering.</span>'+
      '</span>'+
    '</span>';
    var div = document.createElement('div');
    div.className = 'es-tryon-clean';
    div.hidden = true;
    div.innerHTML = ''+
      '<div class="es-tryon-clean__backdrop" data-es-tryon-clean-close></div>'+ 
      '<div class="es-tryon-clean__dialog" role="dialog" aria-modal="true" aria-label="Virtual try-on">'+
        '<div class="es-tryon-clean__panel">'+
          '<div class="es-tryon-clean__main">'+
            '<div class="es-tryon-clean__topbar">'+
              '<div class="es-tryon-clean__title-wrap"><h3 class="es-tryon-clean__title">Virtual Try-On <span class="es-tryon-clean__subtitle" data-es-tryon-clean-product></span></h3></div>'+ 
              '<div class="es-tryon-clean__pupil-banner" data-es-tryon-clean-pupil-banner aria-live="polite"></div>'+ 
              '<button type="button" class="es-tryon-clean__close" aria-label="Close" data-es-tryon-clean-close>×</button>'+ 
            '</div>'+ 
            '<div class="es-tryon-clean__stage" data-es-tryon-clean-stage>'+ 
              '<div class="es-tryon-clean__empty" data-es-tryon-clean-empty>'+ 
                '<h4>Try This Frame On Your Photo</h4>'+ 
                '<p>Use a clear, front-facing photo. Keep your face forward, centered, and level.</p>'+ 
                '<div class="es-tryon-clean__upload-grid">'+ 
                  '<div class="es-tryon-clean__file-group es-tryon-clean__file-group--primary"><label class="es-tryon-clean__file-label">Upload Photo</label><label class="es-tryon-clean__upload-button"><svg class="es-tryon-clean__upload-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8.5 7.5 10 5.5h4l1.5 2h2.2c1 0 1.8.8 1.8 1.8v7.4c0 1-.8 1.8-1.8 1.8H6.3c-1 0-1.8-.8-1.8-1.8V9.3c0-1 .8-1.8 1.8-1.8h2.2Z"/><circle cx="12" cy="13" r="3.2"/></svg><span>Choose Photo</span><input class="es-tryon-clean__file es-tryon-clean__file--hidden" type="file" accept="image/*" data-es-tryon-clean-file aria-label="Upload photo"></label></div>'+ 
                  '<div class="es-tryon-clean__hint"><span class="es-tryon-clean__hint-desktop">You can also drag a photo into this window. </span>Your photo stays on this device.</div>'+ 
                '</div>'+ 
              '</div>'+ 
              '<div class="es-tryon-clean__canvas-wrap" data-es-tryon-clean-canvas-wrap hidden>'+
                '<div class="es-tryon-clean__photo-bg" data-es-tryon-clean-photo-bg hidden></div>'+
                '<div class="es-tryon-clean__canvas-frame">'+
                  '<canvas class="es-tryon-clean__canvas" data-es-tryon-clean-canvas></canvas>'+
                  '<div class="es-tryon-clean__pupil-overlay" data-es-tryon-clean-pupil-overlay aria-live="polite"></div>'+
                  '<div class="es-tryon-clean__canvas-actions">'+
                    '<label class="es-tryon-clean__canvas-change">Change Photo<input class="es-tryon-clean__file es-tryon-clean__file--hidden" type="file" accept="image/*" data-es-tryon-clean-file aria-label="Change photo"></label>'+
                    '<button type="button" class="es-tryon-clean__canvas-remove" data-es-tryon-clean-clear-photo aria-label="Remove saved try-on photo" title="Remove photo"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4h6m-8 4h10m-9 0 .7 11.2c.04.7.62 1.3 1.32 1.3h3.96c.7 0 1.28-.6 1.32-1.3L16 8m-5 3v6m2-6v6"/></svg></button>'+
                  '</div>'+
                  '<div class="es-tryon-clean__pupil-canvas-actions" data-es-tryon-clean-pupil-canvas-review hidden>'+
                    '<button type="button" class="es-tryon-clean__pupil-canvas-apply" data-es-tryon-clean-apply-pupils>Apply</button>'+
                    '<button type="button" class="es-tryon-clean__pupil-canvas-retap" data-es-tryon-clean-retap-pupils>Redo</button>'+
                  '</div>'+
                '</div>'+
              '</div>'+ 
              '<div class="es-tryon-clean__camera" data-es-tryon-clean-camera-panel>'+ 
                '<video class="es-tryon-clean__video" data-es-tryon-clean-video autoplay playsinline muted></video>'+ 
                '<div class="es-tryon-clean__camera-actions">'+ 
                  '<button type="button" class="es-tryon-clean__btn es-tryon-clean__btn--ghost" data-es-tryon-clean-cancel-camera>Cancel</button>'+ 
                  '<button type="button" class="es-tryon-clean__btn es-tryon-clean__btn--primary es-tryon-clean__btn--ghost" data-es-tryon-clean-capture>Use Photo</button>'+ 
                '</div>'+ 
              '</div>'+ 
            '</div>'+ 
          '</div>'+ 
          '<aside class="es-tryon-clean__side">'+ 
            '<h4>Your Try-On Preview</h4>'+ 
            '<p class="es-tryon-clean__help">Use a front-facing photo. Preview only; actual fit may vary. Double-check frame measurements before ordering.</p>'+ 
            '<div class="es-tryon-clean__color-nav" data-es-tryon-clean-color-nav hidden>'+ 
              '<div class="es-tryon-clean__color-title">Frame Color ' + frameColorHelpHtml + '</div>'+ 
              '<div class="es-tryon-clean__color-row">'+ 
                '<button type="button" class="es-tryon-clean__color-btn" data-es-tryon-clean-prev-color aria-label="Previous frame color">←</button>'+ 
                '<div class="es-tryon-clean__color-name" data-es-tryon-clean-color-name>Current color</div>'+ 
                '<button type="button" class="es-tryon-clean__color-btn" data-es-tryon-clean-next-color aria-label="Next frame color">→</button>'+ 
              '</div>'+ 
            '</div>'+ 
            '<div class="es-tryon-clean__calibration" data-es-tryon-clean-calibration>'+ 
              '<div class="es-tryon-clean__pd-row" data-es-tryon-clean-pd-row>'+ 
                '<div class="es-tryon-clean__pd-label">PD <span>(optional)</span>' + pdHelpHtml + '</div>'+ 
                '<div class="es-tryon-clean__pd-fields" data-es-tryon-clean-pd-fields>'+ 
                  '<select class="es-tryon-clean__pd-input es-tryon-clean__pd-select es-tryon-clean__pd-input--single" data-es-tryon-clean-pd-single aria-label="Single pupillary distance">' + singlePdOptions + '</select>'+ 
                  '<div class="es-tryon-clean__pd-dual" data-es-tryon-clean-pd-dual hidden>'+ 
                    '<label class="es-tryon-clean__pd-mini"><select class="es-tryon-clean__pd-input es-tryon-clean__pd-select" data-es-tryon-clean-pd-right aria-label="Right pupillary distance">' + dualRightPdOptions + '</select></label>'+ 
                    '<label class="es-tryon-clean__pd-mini"><select class="es-tryon-clean__pd-input es-tryon-clean__pd-select" data-es-tryon-clean-pd-left aria-label="Left pupillary distance">' + dualLeftPdOptions + '</select></label>'+ 
                  '</div>'+ 
                '</div>'+ 
              '</div>'+ 
              '<label class="es-tryon-clean__pd-check"><input type="checkbox" data-es-tryon-clean-pd-mode> <span>I have 2 PD numbers</span></label>'+ 
              '<div class="es-tryon-clean__calibration-actions">'+
                '<button type="button" class="es-tryon-clean__btn es-tryon-clean__btn--plain es-tryon-clean__mark-btn" data-es-tryon-clean-mark-pupils>Set Pupils</button>'+
                '<div class="es-tryon-clean__pupil-review-actions" data-es-tryon-clean-pupil-review hidden>'+
                  '<button type="button" class="es-tryon-clean__btn es-tryon-clean__btn--primary" data-es-tryon-clean-apply-pupils>Apply</button>'+
                  '<button type="button" class="es-tryon-clean__btn es-tryon-clean__btn--plain" data-es-tryon-clean-retap-pupils>Redo</button>'+
                '</div>'+
              '</div>'+
              '<p class="es-tryon-clean__calibration-note" data-es-tryon-clean-calibration-note>Set each pupil center to place the frame. PD is optional and only improves preview scale.</p>'+ 
            '</div>'+ 
            '<div class="es-tryon-clean__actions">'+ 
            '</div>'+ 
            '<div class="es-tryon-clean__controls">'+ 
              '<div class="es-tryon-clean__control es-tryon-clean__control--size"><label>Preview Size</label><p class="es-tryon-clean__control-help">Adjust only if the frame looks too small or too large.</p><input class="es-tryon-clean__range" type="range" min="70" max="130" step="1" value="100" data-es-tryon-clean-size aria-label="Preview size adjustment"><div class="es-tryon-clean__range-labels"><span>Smaller</span><span>Default</span><span>Larger</span></div></div>'+ 
              '<div class="es-tryon-clean__control es-tryon-clean__control--lighting"><label>Photo Lighting</label><p class="es-tryon-clean__control-help">Adjust your photo only. Frame color stays unchanged.</p><input class="es-tryon-clean__range" type="range" min="90" max="120" step="1" value="105" data-es-tryon-clean-lighting aria-label="Photo lighting adjustment"><div class="es-tryon-clean__range-labels"><span>Darker</span><span>Auto</span><span>Brighter</span></div></div>'+ 
            '</div>'+ 
            '<div class="es-tryon-clean__status" data-es-tryon-clean-status></div>'+ 
            '<div class="es-tryon-clean__notice">Photo stays on this device. Preview only.</div>'+ 
          '</aside>'+ 
        '</div>'+ 
      '</div>';
    document.body.appendChild(div);
    state.modal = div;
    state.canvas = qs('[data-es-tryon-clean-canvas]', div);
    state.ctx = state.canvas.getContext('2d');
    state.video = qs('[data-es-tryon-clean-video]', div);

    // 1148: Live Camera has been removed from the user-facing UI. Mobile file upload already offers Camera/Photo Library,
    // and desktop webcam capture added more complexity than value. Keep the dormant camera code only as a fallback.
    qsa('[data-es-tryon-clean-camera]', div).forEach(function(btn){ btn.remove(); });
    bindModal(div);
    updatePhotoLightingUI();
    updateMarkButton();
    return div;
  }

  function bindModal(modal){
    modal.addEventListener('click', function(e){
      if (e.target.matches('[data-es-tryon-clean-close]') || e.target.closest('.es-tryon-clean__close') || (e.target.classList && e.target.classList.contains('es-tryon-clean__dialog'))) { e.preventDefault(); closeTryOn(); return; }
      var pdHelpClose = e.target.closest('[data-es-tryon-clean-pd-help-close]');
      if (pdHelpClose) { e.preventDefault(); closePdHelp(); return; }
      var pdHelpBtn = e.target.closest('[data-es-tryon-clean-pd-help-btn]');
      if (pdHelpBtn) { e.preventDefault(); togglePdHelp(pdHelpBtn.closest('[data-es-tryon-clean-pd-help]')); return; }
      if (!e.target.closest('[data-es-tryon-clean-pd-help]')) closePdHelp();
      if (e.target.closest('[data-es-tryon-clean-camera]')) { e.preventDefault(); openCamera(); return; }
      if (e.target.closest('[data-es-tryon-clean-clear-photo]')) { e.preventDefault(); clearTryOnPhoto(); return; }
      if (e.target.closest('[data-es-tryon-clean-prev-color]')) { e.preventDefault(); switchFrameChoice(-1); return; }
      if (e.target.closest('[data-es-tryon-clean-next-color]')) { e.preventDefault(); switchFrameChoice(1); return; }
      if (e.target.closest('[data-es-tryon-clean-mark-pupils]')) { e.preventDefault(); if (state.calibrationActive) cancelPupilCalibration(); else startPupilCalibration(true); return; }
      if (e.target.closest('[data-es-tryon-clean-apply-pupils]')) { e.preventDefault(); applyPupilCalibrationReview(); return; }
      if (e.target.closest('[data-es-tryon-clean-retap-pupils]')) { e.preventDefault(); retapPupilCalibration(); return; }
      if (e.target.closest('[data-es-tryon-clean-cancel-camera]')) { e.preventDefault(); stopCamera(); return; }
      if (e.target.closest('[data-es-tryon-clean-capture]')) { e.preventDefault(); captureCamera(); return; }
    });
    qsa('[data-es-tryon-clean-file]', modal).forEach(function(input){
      input.addEventListener('change', function(e){
        var file = e.target.files && e.target.files[0];
        if (file) loadPhotoFile(file);
        e.target.value = '';
      });
      input.addEventListener('click', function(e){ e.stopPropagation(); });
    });
    qsa('[data-es-tryon-clean-pd-help]', modal).forEach(function(wrap){
      wrap.addEventListener('mouseleave', function(){ closePdHelp(); });
    });
    modal.addEventListener('dragover', function(e){
      if (!e.dataTransfer) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      modal.classList.add('is-dragging');
      setStatus('Drop the photo here.');
    });
    modal.addEventListener('dragleave', function(e){
      if (!modal.contains(e.relatedTarget)) modal.classList.remove('is-dragging');
    });
    modal.addEventListener('drop', function(e){
      if (!e.dataTransfer) return;
      e.preventDefault();
      modal.classList.remove('is-dragging');
      handleDroppedFiles(e.dataTransfer.files);
    });
    document.addEventListener('paste', function(e){
      if (!state.modal || state.modal.hidden || !e.clipboardData) return;
      handleDroppedFiles(e.clipboardData.files);
    });
    qs('[data-es-tryon-clean-size]', modal).addEventListener('input', function(e){
      var adjust = parseFloat(e.target.value);
      if (!isFinite(adjust)) adjust = 100;
      var base = state.suggestedScale || state.scale || 0.56;
      state.scale = Math.max(.20, Math.min(1.20, base * adjust / 100));
      updateControlLabels();
      updateSizeBasisText();
      requestDraw();
      setStatus('');
    });
    var lightingInput = qs('[data-es-tryon-clean-lighting]', modal);
    if (lightingInput) {
      lightingInput.addEventListener('input', function(e){
        setPhotoLighting(e.target.value, false);
        setStatus('');
      });
      lightingInput.addEventListener('change', function(e){
        setPhotoLighting(e.target.value, true);
      });
    }
    var pdMode = qs('[data-es-tryon-clean-pd-mode]', modal);
    if (pdMode) pdMode.addEventListener('change', function(){
      updatePdModeUI();
      updateSizeBasisText();
      refreshFitFromPd();
    });
    qsa('[data-es-tryon-clean-pd-single], [data-es-tryon-clean-pd-right], [data-es-tryon-clean-pd-left]', modal).forEach(function(input){
      input.addEventListener('input', function(){ refreshFitFromPd(); });
      input.addEventListener('change', function(){ sanitizePdInputs(); refreshFitFromPd(); });
    });
    state.canvas.addEventListener('pointerdown', onPointerDown);
    state.canvas.addEventListener('pointermove', onPointerMove);
    state.canvas.addEventListener('pointerup', onPointerUp);
    state.canvas.addEventListener('pointercancel', onPointerUp);
    window.addEventListener('resize', function(){ if (!state.modal || state.modal.hidden || !state.photo) return; requestTryOnResizeAndDraw(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && state.modal && !state.modal.hidden) { if (qs('[data-es-tryon-clean-pd-help].is-open', state.modal)) { closePdHelp(); return; } closeTryOn(); } });
  }

  function showEmptyMode(msg){
    if (!state.modal) return;
    state.modal.classList.remove('has-photo');
    state.modal.classList.remove('is-calibrating');
    var empty = qs('[data-es-tryon-clean-empty]', state.modal);
    var wrap = qs('[data-es-tryon-clean-canvas-wrap]', state.modal);
    if (empty) empty.hidden = false;
    if (wrap) wrap.hidden = true;
    setStatus(msg || 'Upload a photo to start.');
    updateSavedPhotoUI();
    updatePhotoBackground();
  }

  function showPhotoMode(msg){
    if (!state.modal) return;
    state.modal.classList.add('has-photo');
    state.modal.classList.toggle('is-calibrating', !!state.calibrationActive);
    var empty = qs('[data-es-tryon-clean-empty]', state.modal);
    var wrap = qs('[data-es-tryon-clean-canvas-wrap]', state.modal);
    if (empty) empty.hidden = true;
    if (wrap) wrap.hidden = false;
    setStatus(msg || '');
    updateSavedPhotoUI();
    updatePhotoLightingUI();
    updatePhotoBackground();
  }


  function isSmallTryOnViewport(){
    try { return window.matchMedia && window.matchMedia('(max-width: 991px)').matches; } catch(err) { return false; }
  }

  function lockTryOnPageScroll(){
    if (!document.body) return;
    if (!state.bodyScrollLocked) {
      state.bodyScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      state.bodyScrollLocked = true;
      if (isSmallTryOnViewport()) {
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + state.bodyScrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }
    }
  }

  function unlockTryOnPageScroll(){
    if (!document.body) return;
    if (state.bodyScrollLocked) {
      var y = state.bodyScrollY || 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      state.bodyScrollLocked = false;
      state.bodyScrollY = 0;
      if (isSmallTryOnViewport()) {
        try { window.scrollTo(0, y); } catch(err) {}
      }
    }
  }

  function openTryOn(opener){
    var modal = buildModal();
    state.activeOpener = opener;
    var choiceData = collectFrameChoices(opener);
    state.frameChoices = choiceData.items || [];
    state.frameChoiceIndex = choiceData.index || 0;
    state.frameWidthMm = getTryOnFrameWidthMm(opener);
    state.frameVerticalOffsetMm = getTryOnVerticalOffsetMm(opener);
    updateColorNav();
    updatePdModeUI();
    updateSizeBasisText();
    updatePhotoLightingUI();
    var activeChoice = getActiveFrameChoice();
    state.frameUrl = activeChoice && activeChoice.url ? activeChoice.url : getMainImageUrl(opener);
    var product = opener && opener.getAttribute('data-es-tryon-title') || '';
    var productEl = qs('[data-es-tryon-clean-product]', modal);
    if (productEl) productEl.textContent = product ? product : '';
    modal.hidden = false;
    document.body.classList.add('es-tryon-clean-open');
    if (document.documentElement) document.documentElement.classList.add('es-tryon-clean-open');
    if (state.photo) { showPhotoMode('Loading frame image...'); } else { showEmptyMode('Loading frame image...'); }
    var restorePromise = state.photo ? Promise.resolve(false) : restoreTryOnSession();
    Promise.all([loadFrame(state.frameUrl, activeChoice), restorePromise]).then(function(){
      updateColorNav();
      updateSizeBasisText();
      if (state.photo) {
        showPhotoMode(state.calibratedPupils ? '' : 'Saved photo loaded. Click Set Pupils to place the frame.');
        // 1137: saved photos were previously drawn at the canvas default 300x150 on first open.
        // Wait until the visible stage has been laid out, resize the canvas from that real area,
        // then draw once. This prevents the tiny-photo first-open state in theme preview/production.
        requestTryOnResizeAndDraw(function(){
          if (state.calibratedPupils) applyFitFromPupils(false);
          else resetFrame();
        });
      } else {
        showEmptyMode('Upload a photo to start.');
      }
      updateSavedPhotoUI();
    }).catch(function(){
      setStatus('Frame image could not be prepared. Please try another product image.');
    });
  }

  function closeTryOn(){
    if (state.calibrationActive) cancelPupilCalibration();
    stopCamera();
    if (state.drawRaf) { cancelAnimationFrame(state.drawRaf); state.drawRaf = 0; }
    if (state.resizeRaf) { cancelAnimationFrame(state.resizeRaf); state.resizeRaf = 0; }
    if (state.modal) state.modal.hidden = true;
    document.body.classList.remove('es-tryon-clean-open');
    if (document.documentElement) document.documentElement.classList.remove('es-tryon-clean-open');
  }

  function loadFrame(url, meta){
    if (!url) return Promise.reject(new Error('missing frame'));
    var skipProcessing = meta && meta.source === 'metafield';
    var key = (skipProcessing ? 'metafield|' : 'auto|') + (normalizeImageUrl(url) || url);
    if (state.frameCache && state.frameCache[key]) {
      state.frame = state.frameCache[key].frame;
      state.frameProcessed = state.frameCache[key].processed;
      state.frameReady = true;
      return Promise.resolve(state.frame);
    }
    return new Promise(function(resolve, reject){
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function(){
        var processed = skipProcessing ? img : makeWhiteTransparent(img);
        if (!state.frameCache) state.frameCache = {};
        state.frameCache[key] = { frame: img, processed: processed };
        state.frame = img;
        state.frameProcessed = processed;
        state.frameReady = true;
        resolve(img);
      };
      img.onerror = function(){
        var fallback = new Image();
        fallback.onload = function(){
          if (!state.frameCache) state.frameCache = {};
          state.frameCache[key] = { frame: fallback, processed: null };
          state.frame = fallback;
          state.frameProcessed = null;
          state.frameReady = true;
          resolve(fallback);
        };
        fallback.onerror = reject;
        fallback.src = url;
      };
      img.src = url;
    });
  }

  function makeWhiteTransparent(img){
    try {
      var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
      var max = 1200, ratio = Math.min(1, max / Math.max(w, h));
      var cw = Math.max(1, Math.round(w * ratio)), ch = Math.max(1, Math.round(h * ratio));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, cw, ch);
      var data = ctx.getImageData(0, 0, cw, ch), px = data.data;
      var total = cw * ch, seen = new Uint8Array(total), queue = [];
      function isBg(idx){
        var off = idx * 4, a = px[off + 3];
        if (a < 8) return true;
        var r = px[off], g = px[off + 1], b = px[off + 2];
        var maxc = Math.max(r,g,b), minc = Math.min(r,g,b), bright = (r+g+b)/3;
        return bright > 235 && (maxc - minc) < 30;
      }
      function push(idx){ if (idx < 0 || idx >= total || seen[idx] || !isBg(idx)) return; seen[idx] = 1; queue.push(idx); }
      for (var x=0; x<cw; x++){ push(x); push((ch-1)*cw+x); }
      for (var y=0; y<ch; y++){ push(y*cw); push(y*cw+cw-1); }
      for (var qi=0; qi<queue.length; qi++){
        var idx = queue[qi], x0 = idx % cw, y0 = (idx - x0) / cw;
        if (x0 > 0) push(idx - 1); if (x0 < cw - 1) push(idx + 1); if (y0 > 0) push(idx - cw); if (y0 < ch - 1) push(idx + cw);
      }
      for (var i=0; i<total; i++) if (seen[i]) px[i*4+3] = 0;
      ctx.putImageData(data,0,0);
      return c;
    } catch(err) { return null; }
  }

  function handleDroppedFiles(files){
    var file = null;
    for (var i=0; files && i<files.length; i++) if (/^image\//i.test(files[i].type || '')) { file = files[i]; break; }
    if (file) loadPhotoFile(file); else setStatus('Please drop an image file.');
  }

  function loadPhotoFile(file){
    if (!/^image\//i.test(file.type || '')) { setStatus('Please choose an image file.'); return; }
    stopCamera();
    var reader = new FileReader();
    reader.onload = function(){
      var img = new Image();
      img.onload = function(){
        state.photoOriginal = img;
        state.photo = img;
        state.photoLighting = 105;
        updatePhotoLightingUI();
        state.calibratedPupils = null;
        state.originalPupils = null;
        resetPupilMarkingState();
        persistTryOnSession();
        updateMarkButton();
        updatePupilReviewUI();
        setPupilStep(null);
        showPhotoMode('Preparing preview...');
        requestTryOnResizeAndDraw(function(){
          resetFrame();
          startPupilCalibration(false);
        });
      };
      img.onerror = function(){ setStatus('Could not read this photo. Please try another image.'); };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  }


  function clampNumber(value, min, max){
    var num = parseFloat(value);
    if (!isFinite(num)) return NaN;
    return Math.max(min, Math.min(max, num));
  }

  function isDualPdMode(){
    var mode = state.modal && qs('[data-es-tryon-clean-pd-mode]', state.modal);
    return !!(mode && mode.checked);
  }

  function updatePdModeUI(){
    if (!state.modal) return;
    var dual = isDualPdMode();
    var singleInput = qs('[data-es-tryon-clean-pd-single]', state.modal);
    var dualWrap = qs('[data-es-tryon-clean-pd-dual]', state.modal);
    if (singleInput) singleInput.hidden = dual;
    if (dualWrap) dualWrap.hidden = !dual;
    updateSizeBasisText();
  }

  function sanitizePdInputs(){
    if (!state.modal) return;
    var single = qs('[data-es-tryon-clean-pd-single]', state.modal);
    var right = qs('[data-es-tryon-clean-pd-right]', state.modal);
    var left = qs('[data-es-tryon-clean-pd-left]', state.modal);
    if (single && single.value !== '') { var sv = clampNumber(single.value, 40, 80); single.value = (isFinite(sv) && sv > 0) ? String(Math.round(sv)) : ''; }
    if (right && right.value !== '') { var rv = clampNumber(right.value, 20, 40); right.value = (isFinite(rv) && rv > 0) ? String(Math.round(rv * 2) / 2) : ''; }
    if (left && left.value !== '') { var lv = clampNumber(left.value, 20, 40); left.value = (isFinite(lv) && lv > 0) ? String(Math.round(lv * 2) / 2) : ''; }
  }

  function getPdValue(){
    if (!state.modal) return 63;
    if (isDualPdMode()) {
      var rInput = qs('[data-es-tryon-clean-pd-right]', state.modal);
      var lInput = qs('[data-es-tryon-clean-pd-left]', state.modal);
      var r = rInput ? parseFloat(rInput.value) : NaN;
      var l = lInput ? parseFloat(lInput.value) : NaN;
      if (isFinite(r) && isFinite(l) && r >= 20 && r <= 40 && l >= 20 && l <= 40) return r + l;
      return 63;
    }
    var input = qs('[data-es-tryon-clean-pd-single]', state.modal);
    var pd = input ? parseFloat(input.value) : NaN;
    if (!isFinite(pd) || pd < 40 || pd > 80) pd = 63;
    return pd;
  }

  function getSelectedPdValue(){
    if (!state.modal) return NaN;
    if (isDualPdMode()) {
      var rInput = qs('[data-es-tryon-clean-pd-right]', state.modal);
      var lInput = qs('[data-es-tryon-clean-pd-left]', state.modal);
      var r = rInput ? parseFloat(rInput.value) : NaN;
      var l = lInput ? parseFloat(lInput.value) : NaN;
      return (isFinite(r) && isFinite(l) && r >= 20 && r <= 40 && l >= 20 && l <= 40) ? (r + l) : NaN;
    }
    var input = qs('[data-es-tryon-clean-pd-single]', state.modal);
    var pd = input ? parseFloat(input.value) : NaN;
    return (isFinite(pd) && pd >= 40 && pd <= 80) ? pd : NaN;
  }

  function formatMm(value){
    var n = parseFloat(value);
    if (!isFinite(n) || n <= 0) return '—';
    return (Math.abs(n - Math.round(n)) < 0.05 ? String(Math.round(n)) : String(Math.round(n * 10) / 10)) + 'mm';
  }

  function updateSizeBasisText(){
    // 1125: keep customer-facing copy conservative; do not expose internal sizing basis.
  }
  function refreshFitFromPd(){
    if (!state.calibratedPupils) {
      setStatus('Set pupils first to place the frame.');
      return;
    }
    applyFitFromPupils(false);
    draw();
    persistTryOnSession();
    updateSizeBasisText();
    setStatus('');
  }

  function drawCanvasInstruction(ctx, msg){
    if (!msg || !state.canvas) return;
    ctx.save();
    var padX = Math.max(14, state.canvas.width * .018);
    var padY = Math.max(9, state.canvas.width * .012);
    var x = Math.max(12, state.canvas.width * .03);
    var y = Math.max(12, state.canvas.height * .03);
    ctx.font = '700 ' + Math.max(13, Math.round(state.canvas.width * .016)) + 'px sans-serif';
    var w = Math.min(state.canvas.width - x * 2, ctx.measureText(msg).width + padX * 2);
    var h = Math.max(32, Math.round(parseInt(ctx.font, 10) * 1.2 + padY * 2));
    ctx.fillStyle = 'rgba(255,255,255,.92)';
    roundRectPath(ctx, x, y, w, h, Math.min(14, h / 2));
    ctx.fill();
    ctx.strokeStyle = 'rgba(209,173,57,.55)';
    ctx.stroke();
    ctx.fillStyle = '#111';
    ctx.fillText(msg, x + padX, y + h / 2 + Math.max(4, Math.round(parseInt(ctx.font, 10) * .32)));
    ctx.restore();
  }

  function roundRectPath(ctx, x, y, w, h, r){
    r = Math.max(0, Math.min(r || 0, w / 2, h / 2));
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
  }

  function scaledPupilsToCanvas(){
    if (!state.calibratedPupils || !state.photo || !state.canvas) return [];
    var pw = state.photo.naturalWidth || state.photo.width, ph = state.photo.naturalHeight || state.photo.height;
    var sx = state.canvas.width / pw, sy = state.canvas.height / ph;
    return [
      { x: state.calibratedPupils.left.x * sx, y: state.calibratedPupils.left.y * sy },
      { x: state.calibratedPupils.right.x * sx, y: state.calibratedPupils.right.y * sy }
    ];
  }

  function updateMarkButton(){
    if (!state.modal) return;
    var btn = qs('[data-es-tryon-clean-mark-pupils]', state.modal);
    if (!btn) return;
    if (state.calibrationActive) btn.textContent = 'Cancel';
    else btn.textContent = state.calibratedPupils ? 'Edit Pupils' : 'Set Pupils';
  }

  function updatePupilReviewUI(){
    if (!state.modal) return;
    var show = !!(state.calibrationActive && state.calibrationReview);
    qsa('[data-es-tryon-clean-pupil-review], [data-es-tryon-clean-pupil-canvas-review]', state.modal).forEach(function(panel){ panel.hidden = !show; });
    state.modal.classList.toggle('is-pupil-review', show);
  }

  function setCalibrationNote(text){
    if (!state.modal) return;
    var note = qs('[data-es-tryon-clean-calibration-note]', state.modal);
    if (note) note.textContent = text || 'Set each pupil center to place the frame. PD is optional and only improves preview scale.';
  }

  function pupilActionVerb(){
    try {
      if (window.matchMedia && (window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(max-width: 700px)').matches)) return 'Tap';
    } catch(err) {}
    return 'Click';
  }

  function setPupilBanner(text){
    if (!state.modal) return;
    var msg = text || '';
    var banner = qs('[data-es-tryon-clean-pupil-banner]', state.modal);
    var overlay = qs('[data-es-tryon-clean-pupil-overlay]', state.modal);
    if (banner) banner.textContent = msg;
    if (overlay) overlay.textContent = msg;
  }

  function setPupilStep(step){
    var verb = pupilActionVerb();
    if (step === 1) {
      setPupilBanner(verb + ' left pupil center');
      setCalibrationNote(verb + ' the center of your left pupil, then your right pupil.');
    } else if (step === 2) {
      setPupilBanner(verb + ' right pupil center');
      setCalibrationNote(verb + ' the center of your right pupil. You can fine-tune both points next.');
    } else if (step === 'review') {
      setPupilBanner('Drag pupil points, then Apply');
      setCalibrationNote('Drag either pupil point if needed, then Apply. Use Redo to place the points again.');
    } else {
      setPupilBanner('');
      setCalibrationNote('Set each pupil center to place the frame. PD is optional and only improves preview scale.');
    }
  }

  function originalPupilsToCanvas(pupils, source){
    if (!pupils || !source || !state.canvas) return null;
    var sw = source.naturalWidth || source.width, sh = source.naturalHeight || source.height;
    if (!sw || !sh) return null;
    return [
      { x:pupils.left.x * state.canvas.width / sw, y:pupils.left.y * state.canvas.height / sh },
      { x:pupils.right.x * state.canvas.width / sw, y:pupils.right.y * state.canvas.height / sh }
    ];
  }

  function copyPupils(pupils){
    if (!pupils || !pupils.left || !pupils.right) return null;
    return {
      left:{ x:pupils.left.x, y:pupils.left.y },
      right:{ x:pupils.right.x, y:pupils.right.y },
      angleDeg:pupils.angleDeg || 0
    };
  }

  function startPupilCalibration(resetPhoto){
    if (!state.photoOriginal && !state.photo) { setStatus('Upload a photo first.'); return; }
    var hasExisting = !!(state.calibratedPupils && state.photo);
    var existingOriginal = (hasExisting && state.originalPupils) ? copyPupils(state.originalPupils) : null;
    state.calibrationActive = true;
    state.calibrationReview = false;
    state.pupilDragIndex = null;
    state.pupilDragActive = false;
    state.pupilDragPoint = null;
    state.calibrationWasExisting = hasExisting;
    state.pupilClicks = [];
    state.calibrationBackup = hasExisting ? {
      photo: state.photo,
      calibratedPupils: copyPupils(state.calibratedPupils),
      originalPupils: copyPupils(state.originalPupils),
      scale: state.scale,
      suggestedScale: state.suggestedScale,
      rot: state.rot,
      x: state.x,
      y: state.y
    } : null;

    // Always mark pupils against the original uploaded/captured photo.
    // This prevents repeated Edit Pupils cycles from rotating an already-leveled canvas again,
    // which can expand the photo bounds and make the preview appear smaller each time.
    var basePhoto = state.photoOriginal || state.photo;
    if (basePhoto) state.photo = basePhoto;
    state.calibrationBase = basePhoto;
    state.calibratedPupils = null;

    if (state.modal) state.modal.classList.add('is-calibrating');
    updateMarkButton();
    updatePupilReviewUI();
    setPupilStep(existingOriginal ? 'review' : 1);
    showPhotoMode('');
    requestTryOnResizeAndDraw(function(){
      if (existingOriginal) {
        var existingCanvasPoints = originalPupilsToCanvas(existingOriginal, basePhoto);
        if (existingCanvasPoints && existingCanvasPoints.length === 2) {
          state.pupilClicks = existingCanvasPoints;
          state.calibrationReview = true;
          updatePupilReviewUI();
          setPupilStep('review');
        } else {
          state.pupilClicks = [];
          setPupilStep(1);
        }
      }
      draw();
      setStatus('');
    });
  }

  function cancelPupilCalibration(){
    if (!state.calibrationActive) return;
    var backup = state.calibrationBackup;
    state.calibrationActive = false;
    state.calibrationReview = false;
    state.pupilDragIndex = null;
    state.pupilDragActive = false;
    state.pupilDragPoint = null;
    state.calibrationWasExisting = false;
    state.pupilClicks = [];
    state.calibrationBase = null;
    state.calibrationBackup = null;
    if (backup) {
      state.photo = backup.photo || state.photo;
      state.calibratedPupils = copyPupils(backup.calibratedPupils);
      state.originalPupils = copyPupils(backup.originalPupils);
      state.scale = backup.scale;
      state.suggestedScale = backup.suggestedScale || backup.scale || state.suggestedScale || 0.56;
      state.rot = backup.rot;
      state.x = backup.x;
      state.y = backup.y;
    }
    if (state.modal) state.modal.classList.remove('is-calibrating');
    updateMarkButton();
    updatePupilReviewUI();
    setPupilStep(null);
    showPhotoMode('');
    requestTryOnResizeAndDraw(function(){
      if (state.calibratedPupils) applyFitFromPupils(true);
      draw();
    });
  }

  function retapPupilCalibration(){
    if (!state.calibrationActive) return;
    state.pupilClicks = [];
    state.calibrationReview = false;
    state.pupilDragIndex = null;
    state.pupilDragActive = false;
    state.pupilDragPoint = null;
    updatePupilReviewUI();
    setPupilStep(1);
    setStatus('');
    draw();
  }

  function enterPupilReview(){
    if (!state.calibrationActive || state.pupilClicks.length < 2) return;
    state.calibrationReview = true;
    state.pupilDragIndex = null;
    state.pupilDragActive = false;
    state.pupilDragPoint = null;
    updatePupilReviewUI();
    setPupilStep('review');
    setStatus('');
    draw();
  }

  function applyPupilCalibrationReview(){
    if (!state.calibrationActive || state.pupilClicks.length < 2) return;
    var first = state.pupilClicks[0], second = state.pupilClicks[1];
    state.calibrationActive = false;
    state.calibrationReview = false;
    state.pupilDragIndex = null;
    state.pupilDragActive = false;
    state.pupilDragPoint = null;
    state.calibrationWasExisting = false;
    state.calibrationBackup = null;
    if (state.modal) state.modal.classList.remove('is-calibrating');
    updatePupilReviewUI();
    updateMarkButton();
    setPupilStep(null);
    calibrateFromPupils(first, second);
  }

  function handlePupilClick(evt){
    if (!state.photo || !state.canvas || state.calibrationReview) return;
    var p = canvasPoint(evt);
    if (state.pupilClicks.length >= 2) state.pupilClicks = [];
    state.pupilClicks.push(p);
    if (state.pupilClicks.length === 1) {
      setPupilStep(2);
      setStatus('');
      draw();
      return;
    }
    if (state.pupilClicks.length >= 2) enterPupilReview();
  }

  function nearestPupilIndex(p){
    if (!p || state.pupilClicks.length < 2) return 0;
    var a = state.pupilClicks[0], b = state.pupilClicks[1];
    var da = Math.pow(p.x - a.x, 2) + Math.pow(p.y - a.y, 2);
    var db = Math.pow(p.x - b.x, 2) + Math.pow(p.y - b.y, 2);
    return da <= db ? 0 : 1;
  }

  function beginPupilReviewDrag(evt){
    if (!state.photo || !state.canvas || state.pupilClicks.length < 2) return;
    var p = canvasPoint(evt);
    var idx = nearestPupilIndex(p);
    state.pupilDragIndex = idx;
    state.pupilDragActive = true;
    state.pupilDragPoint = p;
    state.pupilClicks[idx] = p;
    setPupilStep('review');
    try{state.canvas.setPointerCapture(evt.pointerId);}catch(err){}
    draw();
  }

  function movePupilReviewDrag(evt){
    if (!state.calibrationActive || !state.calibrationReview || !state.pupilDragActive || state.pupilDragIndex === null) return;
    var p = canvasPoint(evt);
    state.pupilDragPoint = p;
    state.pupilClicks[state.pupilDragIndex] = p;
    requestDraw();
  }

  function endPupilReviewDrag(evt){
    if (!state.pupilDragActive) return;
    state.pupilDragActive = false;
    state.pupilDragIndex = null;
    state.pupilDragPoint = null;
    try{state.canvas.releasePointerCapture(evt.pointerId);}catch(err){}
    draw();
  }

  function crossAt(ctx, p, label, reviewMode){
    if (!p) return;
    ctx.save();

    // 1144: return to the simple original pupil marker style.
    // The visible marker is only a clean cross + small gold center dot;
    // the actual draggable hit area remains generous through pointer logic.
    var len = Math.max(18, Math.min(30, state.canvas.width * (reviewMode ? .032 : .04)));
    var dotRadius = Math.max(3, Math.min(4.6, state.canvas.width * .0055));

    ctx.shadowColor = 'rgba(0,0,0,.38)';
    ctx.shadowBlur = 2;
    ctx.strokeStyle = 'rgba(255,255,255,.94)';
    ctx.lineWidth = Math.max(1.2, Math.min(1.8, state.canvas.width * .0019));
    ctx.beginPath();
    ctx.moveTo(p.x - len, p.y);
    ctx.lineTo(p.x + len, p.y);
    ctx.moveTo(p.x, p.y - len);
    ctx.lineTo(p.x, p.y + len);
    ctx.stroke();

    ctx.shadowBlur = 1;
    ctx.fillStyle = '#d1ad39';
    ctx.beginPath();
    ctx.arc(p.x, p.y, dotRadius, 0, Math.PI * 2);
    ctx.fill();

    ctx.restore();
  }

  function drawPupilMagnifier(ctx){
    if (!state.photo || !state.pupilDragActive || !state.pupilDragPoint) return;
    var p = state.pupilDragPoint;
    var cw = state.canvas.width, ch = state.canvas.height;
    var radius = Math.max(48, Math.min(76, cw * .11));
    var zoom = 2.6;
    var mx = p.x + radius + 22;
    var my = p.y - radius - 24;
    if (mx + radius > cw - 8) mx = p.x - radius - 22;
    if (mx - radius < 8) mx = Math.min(cw - radius - 8, Math.max(radius + 8, p.x));
    if (my - radius < 8) my = p.y + radius + 24;
    if (my + radius > ch - 8) my = Math.min(ch - radius - 8, Math.max(radius + 8, p.y));
    var imgW = state.photo.naturalWidth || state.photo.width;
    var imgH = state.photo.naturalHeight || state.photo.height;
    var sx = p.x / cw * imgW;
    var sy = p.y / ch * imgH;
    var sw = radius * 2 / zoom * imgW / cw;
    var sh = radius * 2 / zoom * imgH / ch;
    ctx.save();
    ctx.beginPath(); ctx.arc(mx, my, radius, 0, Math.PI*2); ctx.clip();
    ctx.save();
    try { ctx.filter = getPhotoLightingFilter(); } catch(err) {}
    ctx.drawImage(state.photo, sx - sw/2, sy - sh/2, sw, sh, mx - radius, my - radius, radius*2, radius*2);
    ctx.restore();
    ctx.strokeStyle = 'rgba(255,255,255,.95)';
    ctx.lineWidth = 1.3;
    ctx.beginPath(); ctx.moveTo(mx-radius, my); ctx.lineTo(mx+radius, my); ctx.moveTo(mx, my-radius); ctx.lineTo(mx, my+radius); ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.strokeStyle = '#d1ad39';
    ctx.lineWidth = 2.2;
    ctx.beginPath(); ctx.arc(mx, my, radius, 0, Math.PI*2); ctx.stroke();
    ctx.restore();
  }

  function calibrateFromPupils(p1Canvas, p2Canvas){
    var base = state.calibrationBase || state.photoOriginal || state.photo;
    if (!base) return;
    var bw = base.naturalWidth || base.width, bh = base.naturalHeight || base.height;
    var sx = bw / state.canvas.width, sy = bh / state.canvas.height;
    var p1 = { x:p1Canvas.x * sx, y:p1Canvas.y * sy };
    var p2 = { x:p2Canvas.x * sx, y:p2Canvas.y * sy };
    if (p2.x < p1.x) { var t = p1; p1 = p2; p2 = t; }
    var angle = Math.atan2(p2.y - p1.y, p2.x - p1.x);
    var deg = angle * 180 / Math.PI;
    var corrected = buildLeveledPhoto(base, p1, p2, angle);
    if (!corrected) { setStatus('Could not calibrate this photo. Please try again.'); return; }
    state.photo = corrected.canvas;
    state.originalPupils = { left:{ x:p1.x, y:p1.y }, right:{ x:p2.x, y:p2.y }, angleDeg:deg };
    state.calibratedPupils = { left:corrected.left, right:corrected.right, angleDeg:deg };
    state.pupilClicks = [];
    state.calibrationBase = null;
    persistTryOnSession();
    updateMarkButton();
    updatePupilReviewUI();
    showPhotoMode('');
    requestTryOnResizeAndDraw(function(){
      applyFitFromPupils(false);
      setStatus('');
    });
  }

  function buildLeveledPhoto(img, left, right, angle){
    try {
      var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
      var rot = -angle, cos = Math.cos(rot), sin = Math.sin(rot);

      // 1130: keep the corrected photo at the original aspect/size and scale it as a cover image.
      // The older expanded-canvas approach preserved the full rotated rectangle, but it created
      // white corner triangles and made the visible photo shrink after every pupil correction.
      // Cover-cropping keeps the preview filled, stable, and visually closer to the original photo.
      var absCos = Math.abs(cos), absSin = Math.abs(sin);
      var coverScale = Math.max(
        (w * absCos + h * absSin) / Math.max(1, w),
        (w * absSin + h * absCos) / Math.max(1, h)
      );
      if (!isFinite(coverScale) || coverScale < 1) coverScale = 1;

      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d');
      ctx.save();
      ctx.translate(w/2, h/2);
      ctx.rotate(rot);
      ctx.scale(coverScale, coverScale);
      ctx.drawImage(img, -w/2, -h/2, w, h);
      ctx.restore();
      function tx(p){
        var rx = (p.x - w/2) * coverScale, ry = (p.y - h/2) * coverScale;
        return { x:w/2 + rx*cos - ry*sin, y:h/2 + rx*sin + ry*cos };
      }
      return { canvas:c, left:tx(left), right:tx(right) };
    } catch(err) { return null; }
  }

  function getFrameSource(){
    return state.frameProcessed || state.frame || null;
  }

  function getFrameAspect(source){
    if (!source) return 2;
    var w = source.width || (state.frame && state.frame.naturalWidth) || 1;
    var h = source.height || (state.frame && state.frame.naturalHeight) || 1;
    return Math.max(0.1, w / Math.max(1, h));
  }

  function getFrameAnchorYRatio(){
    var active = getActiveFrameChoice ? getActiveFrameChoice() : null;
    var raw = active && (active.anchor_y || active.anchorY || active.anchor || '');
    var val = parseFloat(raw);
    if (isFinite(val)) {
      if (val > 1) val = val / 100;
      return Math.max(0.35, Math.min(0.65, val));
    }
    return state.frameAnchorYRatio || 0.5;
  }

  function alignFrameAnchorToPupilLine(pupilY){
    var source = getFrameSource();
    if (!source || !state.canvas) { state.y = pupilY; return; }
    var fw = state.canvas.width * state.scale;
    var fh = fw / getFrameAspect(source);
    var anchorY = getFrameAnchorYRatio();
    state.y = pupilY - (anchorY - 0.5) * fh;
  }

  function getCurrentFrameWidthMm(){
    var active = getActiveFrameChoice ? getActiveFrameChoice() : null;
    var activeVal = active && (active.frame_width || active.frameWidth || active.frame_width_mm || active.frameWidthMm || '');
    activeVal = normalizeMmValue(activeVal);
    if (isFinite(activeVal)) return activeVal;
    var val = normalizeMmValue(state.frameWidthMm);
    return isFinite(val) ? val : 140;
  }

  function getCurrentFrameVerticalOffsetMm(){
    var active = getActiveFrameChoice ? getActiveFrameChoice() : null;
    var activeVal = active && (active.vertical_offset_mm || active.verticalOffsetMm || active.vertical_offset || active.verticalOffset || '');
    activeVal = normalizeVerticalOffsetMm(activeVal);
    if (isFinite(activeVal)) return activeVal;
    var val = normalizeVerticalOffsetMm(state.frameVerticalOffsetMm);
    return isFinite(val) ? val : 3;
  }

  function applyFitFromPupils(keepScaleIfManual){
    if (!state.calibratedPupils || !state.canvas || !state.photo) return false;
    var pw = state.photo.naturalWidth || state.photo.width, ph = state.photo.naturalHeight || state.photo.height;
    var sx = state.canvas.width / pw, sy = state.canvas.height / ph;
    var l = { x:state.calibratedPupils.left.x * sx, y:state.calibratedPupils.left.y * sy };
    var r = { x:state.calibratedPupils.right.x * sx, y:state.calibratedPupils.right.y * sy };
    var mid = { x:(l.x + r.x)/2, y:(l.y + r.y)/2 };
    var eyeDist = Math.max(1, Math.hypot(r.x - l.x, r.y - l.y));
    state.x = mid.x;
    var pd = getPdValue();
    var pxPerMm = eyeDist / Math.max(1, pd);
    if (!keepScaleIfManual) {
      var frameWidthMm = getCurrentFrameWidthMm();
      var targetW = eyeDist * (frameWidthMm / Math.max(1, pd));
      var nextScale = targetW / Math.max(1, state.canvas.width);
      state.suggestedScale = Math.max(.20, Math.min(1.20, nextScale));
      state.scale = state.suggestedScale;
      var size = qs('[data-es-tryon-clean-size]', state.modal);
      if (size) size.value = 100;
      updateControlLabels();
    }
    updateSizeBasisText();
    // The PNG is expected to be tightly cropped: PNG width ~= real frame width.
    // Place the frame center line about 3mm below the confirmed pupil line for a more natural fit.
    var verticalOffsetPx = getCurrentFrameVerticalOffsetMm() * pxPerMm;
    alignFrameAnchorToPupilLine(mid.y + verticalOffsetPx);
    return true;
  }

  function requestDraw(){
    if (state.drawRaf) return;
    state.drawRaf = requestAnimationFrame(function(){
      state.drawRaf = 0;
      draw();
    });
  }

  function requestTryOnResizeAndDraw(afterResize){
    if (!state.photo) return;
    if (state.resizeRaf) cancelAnimationFrame(state.resizeRaf);
    state.resizeRaf = requestAnimationFrame(function(){
      state.resizeRaf = requestAnimationFrame(function(){
        state.resizeRaf = 0;
        resizeCanvasForPhoto();
        if (typeof afterResize === 'function') afterResize();
        else if (state.calibratedPupils) applyFitFromPupils(true);
        draw();
      });
    });
  }

  function resizeCanvasForPhoto(){
    if (!state.photo || !state.canvas) return;
    var wrap = qs('[data-es-tryon-clean-canvas-wrap]', state.modal);
    var stage = qs('[data-es-tryon-clean-stage]', state.modal);
    var rect = wrap && !wrap.hidden ? wrap.getBoundingClientRect() : null;
    var stageRect = stage ? stage.getBoundingClientRect() : null;
    var rawW = rect && rect.width > 80 ? rect.width : (stageRect && stageRect.width > 80 ? stageRect.width : 760);
    var rawH = rect && rect.height > 80 ? rect.height : (stageRect && stageRect.height > 80 ? stageRect.height : 620);
    var maxW = Math.max(420, rawW - 4);
    var maxH = Math.max(320, rawH - 4);
    var pw = state.photo.naturalWidth || state.photo.width, ph = state.photo.naturalHeight || state.photo.height;
    var ratio = Math.min(maxW / pw, maxH / ph, 1.25);
    state.canvas.width = Math.max(1, Math.round(pw * ratio));
    state.canvas.height = Math.max(1, Math.round(ph * ratio));
  }
  function resetFrame(){
    if (!state.canvas) return;
    state.scale = state.suggestedScale || 0.56; state.rot = 0;
    if (state.calibratedPupils) {
      applyFitFromPupils(false);
    } else {
      centerFrame();
      var size = qs('[data-es-tryon-clean-size]', state.modal);
      if (size) size.value = 100;
      updateControlLabels();
    }
  }
  function centerFrame(){
    if (!state.canvas) return;
    if (state.calibratedPupils && applyFitFromPupils(true)) return;
    state.x = state.canvas.width / 2; state.y = state.canvas.height * 0.42;
  }
  function updateControlLabels(){
    var range = qs('[data-es-tryon-clean-size]', state.modal);
    if (!range) return;
    var adjust = parseFloat(range.value);
    var label = 'Default preview size';
    if (isFinite(adjust)) {
      if (adjust < 98) label = 'Smaller preview size';
      else if (adjust > 102) label = 'Larger preview size';
    }
    range.setAttribute('aria-valuetext', label);
  }
  function normalizeTryOnDepthValue(value){
    if (value === null || typeof value === 'undefined') return '';
    if (typeof value === 'object') {
      value = value.mode || value.value || value.key || value.name || value.handle ||
        (value.system && value.system.handle) || value.label || value.title || '';
    }
    var s = String(value).toLowerCase().trim().replace(/[_\s]+/g, '-');
    if (!s) return '';
    if (s === 'none' || s === 'no' || s === 'false' || s === 'disabled' || s === 'disable' || s === 'off') return 'off';
    if (s === 'light' || s === 'low' || s === 'soft' || s === 'thin' || s === 'metal' || s === 'thin-metal') return 'soft';
    if (s === 'heavy' || s === 'high' || s === 'strong' || s === 'thick' || s === 'thick-plastic' || s === 'acetate' || s === 'plastic') return 'strong';
    if (s === 'rimless' || s === 'frameless') return 'off';
    if (s === 'standard' || s === 'normal') return 'default';
    if (s === 'auto') return 'auto';
    return s;
  }

  function getActiveFrameMetaValue(keys){
    var active = getActiveFrameChoice ? getActiveFrameChoice() : null;
    for (var i = 0; active && i < keys.length; i++) {
      var k = keys[i];
      if (active[k] !== null && typeof active[k] !== 'undefined' && String(active[k]).trim() !== '') return active[k];
    }
    for (var j = 0; state.activeOpener && j < keys.length; j++) {
      var name = String(keys[j]).replace(/[A-Z]/g, function(m){ return '-' + m.toLowerCase(); }).replace(/_/g, '-');
      var attr = state.activeOpener.getAttribute('data-es-' + name) || state.activeOpener.getAttribute('data-es-tryon-' + name) || state.activeOpener.getAttribute('data-' + name);
      if (attr !== null && typeof attr !== 'undefined' && String(attr).trim() !== '') return attr;
    }
    return '';
  }

  function getFrameHintText(){
    var active = getActiveFrameChoice ? getActiveFrameChoice() : null;
    var parts = [];
    if (active) parts.push(active.label || '', active.frame_type || '', active.depth_mode || '');
    if (state.activeOpener) parts.push(state.activeOpener.getAttribute('data-es-tryon-title') || '', state.activeOpener.getAttribute('data-es-tryon-depth-mode') || '', state.activeOpener.getAttribute('data-es-tryon-frame-type') || '');
    return parts.join(' ').toLowerCase();
  }

  function estimateFrameDepthProfile(source){
    var fallback = { coverage:.18, darkness:.62, darkRatio:.60, isDark:true, strength:1, avgLum:95, autoPreset:'strong' };
    if (!source) return fallback;
    var cacheKey = source.__esTryOnDepthProfileKey || '';
    if (cacheKey && state.frameDepthCache && state.frameDepthCache[cacheKey]) return state.frameDepthCache[cacheKey];
    try {
      var sw = source.width || (state.frame && state.frame.naturalWidth) || 1;
      var sh = source.height || (state.frame && state.frame.naturalHeight) || 1;
      var max = 92;
      var ratio = Math.min(1, max / Math.max(sw, sh));
      var cw = Math.max(12, Math.round(sw * ratio));
      var ch = Math.max(12, Math.round(sh * ratio));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var cctx = c.getContext('2d', { willReadFrequently:true });
      cctx.drawImage(source, 0, 0, cw, ch);
      var data = cctx.getImageData(0, 0, cw, ch).data;
      var opaque = 0, lum = 0, dark = 0, veryLight = 0;
      for (var i=0; i<data.length; i+=4) {
        var a = data[i+3];
        if (a < 42) continue;
        opaque++;
        var l = data[i]*0.299 + data[i+1]*0.587 + data[i+2]*0.114;
        lum += l;
        if (l < 110) dark++;
        if (l > 188) veryLight++;
      }
      var total = Math.max(1, cw * ch);
      var coverage = opaque / total;
      var avgLum = opaque ? lum / opaque : 145;
      var darkRatio = opaque ? dark / opaque : 0;
      var lightRatio = opaque ? veryLight / opaque : 0;
      var thickness = Math.max(0, Math.min(1, (coverage - .055) / .22));
      var darkness = Math.max(0, Math.min(1, (150 - avgLum) / 115));
      var hint = getFrameHintText();
      var autoPreset = 'default';
      if (/rimless|frameless|无框/.test(hint) || coverage < .026) autoPreset = 'off';
      else if (/titanium|metal|wire|gold|silver|gunmetal|steel|钛|金属/.test(hint) || coverage < .070) autoPreset = 'soft';
      else if (/transparent|clear|crystal|white|cream|champagne|pink|rose|浅|透明/.test(hint) || (lightRatio > .45 && avgLum > 165)) autoPreset = 'soft';
      else if (/black|dark|tortoise|acetate|plastic|chunky|thick|bold|黑|玳瑁/.test(hint) || (coverage > .125 && (avgLum < 140 || darkRatio > .38))) autoPreset = 'strong';
      var strength = Math.max(.50, Math.min(1.24, .56 + thickness * .45 + darkness * .20));
      if (autoPreset === 'soft') strength = Math.min(strength, .72);
      if (autoPreset === 'off') strength = Math.min(strength, .25);
      if (autoPreset === 'strong') strength = Math.max(strength, .92);
      var profile = { coverage:coverage, darkness:darkness, darkRatio:darkRatio, lightRatio:lightRatio, avgLum:avgLum, isDark:avgLum < 135 || darkRatio > .58, strength:strength, autoPreset:autoPreset };
      cacheKey = String(sw) + 'x' + String(sh) + '|' + Math.round(coverage * 1000) + '|' + Math.round(avgLum) + '|' + Math.round(darkRatio * 100);
      source.__esTryOnDepthProfileKey = cacheKey;
      if (!state.frameDepthCache) state.frameDepthCache = {};
      state.frameDepthCache[cacheKey] = profile;
      return profile;
    } catch(err) { return fallback; }
  }

  function resolveFrameDepthSettings(profile){
    var requested = normalizeTryOnDepthValue(getActiveFrameMetaValue(['depth_mode','depthMode','tryon_depth_mode','tryonDepthMode','depth','frame_type','frameType','tryon_frame_type','tryonFrameType']));
    var preset = requested && requested !== 'auto' ? requested : (profile && profile.autoPreset ? profile.autoPreset : 'default');
    if (!preset || preset === 'auto') preset = 'default';
    var p = {
      preset:preset,
      enabled:preset !== 'off',
      shadowMul:1,
      edgeMul:1,
      darkMul:1,
      blurMul:1,
      allowLocal:true,
      allowPerspective:true
    };
    if (preset === 'soft') {
      // 1176: make manual soft visibly different from strong.
      // Soft keeps only a light grounding cue, with almost no color/depth darkening.
      p.shadowMul = .34; p.edgeMul = .36; p.darkMul = .18; p.blurMul = .72;
      p.allowPerspective = false;
    } else if (preset === 'strong') {
      // Strong is intended for black/chunky acetate frames. It adds a clearer contact
      // shadow and deeper edge, while avoiding the gray/highlight layer that made 1171/1172 look washed out.
      p.shadowMul = 1.68; p.edgeMul = 1.42; p.darkMul = 1.55; p.blurMul = 1.08;
    } else if (preset === 'off') {
      p.shadowMul = 0; p.edgeMul = 0; p.darkMul = 0; p.blurMul = 0; p.allowLocal = false; p.allowPerspective = false;
    }
    if (profile && profile.lightRatio > .42 && preset !== 'strong') {
      p.shadowMul *= .75; p.edgeMul *= .70; p.darkMul *= .65;
    }
    return p;
  }

  function drawDepthMask(ctx, source, fw, fh, alpha, blurPx, offsetX, offsetY, scaleX, scaleY, filterExtra, region){
    if (!alpha || alpha <= 0) return;
    ctx.save();
    if (region) {
      ctx.beginPath();
      ctx.rect(-fw/2 + fw * (region.x || 0), -fh/2 + fh * (region.y || 0), fw * (region.w || 1), fh * (region.h || 1));
      ctx.clip();
    }
    ctx.globalAlpha = Math.max(0, Math.min(1, alpha || 0));
    try { ctx.filter = 'brightness(0) saturate(0) blur(' + Math.max(0, blurPx || 0).toFixed(2) + 'px)' + (filterExtra || ''); } catch(err) {}
    ctx.translate(offsetX || 0, offsetY || 0);
    ctx.scale(scaleX || 1, scaleY || 1);
    ctx.drawImage(source, -fw/2, -fh/2, fw, fh);
    ctx.restore();
  }

  function getAutoPerspectiveYawDeg(){
    var raw = getActiveFrameMetaValue(['perspective_yaw','perspectiveYaw','tryon_perspective_yaw','tryonPerspectiveYaw']);
    var manual = parseFloat(raw);
    if (isFinite(manual)) return Math.max(-5, Math.min(5, manual));
    if (!state.calibratedPupils || !state.canvas) return 0;
    // We only use this as a tiny visual cue. It is based on the fitted face position,
    // not a true 3D face landmark yaw, so keep it intentionally conservative.
    var offset = (state.x - state.canvas.width / 2) / Math.max(1, state.canvas.width);
    if (Math.abs(offset) < .045) return 0;
    return Math.max(-2.4, Math.min(2.4, -offset * 8));
  }

  function applyPseudoPerspectiveTransform(ctx, yawDeg){
    var yaw = Math.max(-5, Math.min(5, yawDeg || 0));
    if (Math.abs(yaw) < .05) return;
    var squeeze = 1 - Math.min(.035, Math.abs(yaw) * .006);
    var skew = Math.max(-.008, Math.min(.008, yaw * .0016));
    ctx.transform(squeeze, 0, skew, 1, 0, 0);
  }

  function drawMaskedSideShade(ctx, source, fw, fh, yawDeg, alpha){
    if (!source || !alpha || Math.abs(yawDeg || 0) < .7) return;
    var w = Math.max(2, Math.round(fw));
    var h = Math.max(2, Math.round(fh));
    if (w > 1400 || h > 900) { var r = Math.min(1400 / w, 900 / h); w = Math.round(w * r); h = Math.round(h * r); }
    try {
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var cctx = c.getContext('2d');
      var grad = cctx.createLinearGradient(0, 0, w, 0);
      if (yawDeg > 0) {
        grad.addColorStop(0, 'rgba(0,0,0,' + alpha.toFixed(3) + ')');
        grad.addColorStop(.48, 'rgba(0,0,0,0)');
        grad.addColorStop(1, 'rgba(0,0,0,0)');
      } else {
        grad.addColorStop(0, 'rgba(0,0,0,0)');
        grad.addColorStop(.52, 'rgba(0,0,0,0)');
        grad.addColorStop(1, 'rgba(0,0,0,' + alpha.toFixed(3) + ')');
      }
      cctx.fillStyle = grad;
      cctx.fillRect(0, 0, w, h);
      cctx.globalCompositeOperation = 'destination-in';
      cctx.drawImage(source, 0, 0, w, h);
      cctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(c, -fw/2, -fh/2, fw, fh);
    } catch(err) {}
  }

  function drawFrameOnCanvas(ctx){
    if (!state.photo || !state.frameReady || !state.frame) return;
    var source = getFrameSource();
    if (!source) return;
    var aspect = getFrameAspect(source);
    var fw = state.canvas.width * state.scale, fh = fw / aspect;
    var profile = estimateFrameDepthProfile(source);
    var settings = resolveFrameDepthSettings(profile);
    var s = profile && profile.strength ? profile.strength : 1;
    var isDarkFrame = !!(profile && (profile.isDark || profile.darkness > .38 || profile.darkRatio > .42));
    var mobileMul = isSmallTryOnViewport() ? .88 : 1;

    ctx.save();
    ctx.translate(state.x,state.y);
    var yawDeg = settings.allowPerspective ? getAutoPerspectiveYawDeg() : 0;
    applyPseudoPerspectiveTransform(ctx, yawDeg);

    if (settings.enabled) {
      var softBlur = Math.max(1.5, Math.min(6.8, fw * (.0125 + .0022 * s))) * settings.blurMul * mobileMul;
      var closeBlur = Math.max(.45, Math.min(2.35, fw * .0047)) * settings.blurMul * mobileMul;
      var contactY = Math.max(.85, Math.min(5.6, fw * (.0092 + .0018 * s)));
      var contactAlphaBase = settings.preset === 'soft'
        ? Math.max(.012, Math.min(isDarkFrame ? .045 : .040, .020 + .014 * s))
        : Math.max(.040, Math.min(isDarkFrame ? .120 : .095, .050 + .034 * s));
      var edgeAlphaBase = settings.preset === 'soft'
        ? Math.max(.006, Math.min(isDarkFrame ? .026 : .024, .010 + .010 * s))
        : Math.max(.028, Math.min(isDarkFrame ? .078 : .065, .032 + .022 * s));
      var bridgeAlphaBase = settings.preset === 'soft'
        ? Math.max(.006, Math.min(.025, .009 + .007 * s))
        : Math.max(.018, Math.min(.060, .020 + .018 * s));
      var contactAlpha = contactAlphaBase * settings.shadowMul;
      var edgeAlpha = edgeAlphaBase * settings.edgeMul;
      var bridgeAlpha = bridgeAlphaBase * settings.shadowMul;

      // 1174: keep the overall grounding subtle, then bias the stronger contact shadow
      // toward the lower rim and nose bridge. This gives depth without a gray halo around
      // the entire black frame.
      drawDepthMask(ctx, source, fw, fh, contactAlpha * .36, softBlur, 0, contactY, 1.006, 1.010, '', null);
      drawDepthMask(ctx, source, fw, fh, contactAlpha, softBlur, 0, contactY, 1.008, 1.014, '', {x:-.03,y:.45,w:1.06,h:.62});
      drawDepthMask(ctx, source, fw, fh, bridgeAlpha, Math.max(.8, closeBlur * 1.15), 0, Math.max(.45, contactY * .46), 1.002, 1.004, '', {x:.36,y:.31,w:.28,h:.36});
      drawDepthMask(ctx, source, fw, fh, edgeAlpha, closeBlur, 0, Math.max(.28, fw*.0026), 1.001, 1.002, '', null);
    }

    ctx.save();
    if (settings.enabled) {
      try {
        if (isDarkFrame) {
          if (settings.preset === 'soft') ctx.filter = 'brightness(0.985) contrast(1.045) saturate(1.00)';
          else if (settings.preset === 'strong') ctx.filter = 'brightness(0.875) contrast(1.24) saturate(1.02)';
          else ctx.filter = 'brightness(0.92) contrast(1.15) saturate(1.01)';
        } else {
          ctx.filter = settings.preset === 'soft'
            ? 'brightness(1.00) contrast(1.005) saturate(1.00)'
            : 'brightness(0.985) contrast(1.035) saturate(1.00)';
        }
      } catch(err) {}
      var inlineShadowAlpha = settings.preset === 'soft'
        ? Math.max(.018, Math.min(.055, (.028 + .012 * s) * settings.edgeMul))
        : Math.max(.07, Math.min(.20, (.085 + .035 * s) * settings.edgeMul));
      ctx.shadowColor = 'rgba(0,0,0,' + inlineShadowAlpha.toFixed(3) + ')';
      ctx.shadowBlur = Math.max(.45, Math.min(settings.preset === 'soft' ? 1.55 : 3.9, fw * (.0038 + .0014 * s))) * settings.blurMul * mobileMul;
      ctx.shadowOffsetY = Math.max(.18, Math.min(settings.preset === 'soft' ? 1.1 : 2.2, fw * (.0028 + .0008 * s)));
    }
    ctx.drawImage(source,-fw/2,-fh/2,fw,fh);
    ctx.restore();

    if (settings.enabled && isDarkFrame) {
      ctx.save();
      var minDark = settings.preset === 'soft' ? .004 : .020;
      var maxDark = settings.preset === 'soft' ? .020 : .090;
      ctx.globalAlpha = Math.max(minDark, Math.min(maxDark, (.026 + .014 * s) * settings.darkMul));
      try { ctx.filter = settings.preset === 'soft' ? 'brightness(0.72) contrast(1.04) saturate(1.00)' : 'brightness(0.50) contrast(1.15) saturate(1.00)'; } catch(err) {}
      ctx.drawImage(source,-fw/2,-fh/2,fw,fh);
      ctx.restore();
    }

    if (settings.enabled) {
      var sideAlphaBase = settings.preset === 'soft' ? Math.max(.004, Math.min(.014, .006 + .004 * s)) : Math.max(.018, Math.min(.068, .020 + .012 * s));
      drawMaskedSideShade(ctx, source, fw, fh, yawDeg, sideAlphaBase * settings.shadowMul);
    }

    ctx.restore();
  }

  function draw(){
    if (!state.canvas || !state.ctx) return;
    var ctx = state.ctx;
    ctx.clearRect(0,0,state.canvas.width,state.canvas.height);
    if (state.photo) drawPhotoOnly(ctx,state.photo,0,0,state.canvas.width,state.canvas.height);
    if (!state.calibrationActive) drawFrameOnCanvas(ctx);
    if (state.photo && state.calibrationActive){
      if (state.calibrationReview) {
        if (state.pupilClicks[0]) crossAt(ctx, state.pupilClicks[0], 'L', true);
        if (state.pupilClicks[1]) crossAt(ctx, state.pupilClicks[1], 'R', true);
        drawPupilMagnifier(ctx);
      } else {
        if (state.pupilClicks[0]) crossAt(ctx, state.pupilClicks[0], 'L', false);
        if (state.pupilClicks[1]) crossAt(ctx, state.pupilClicks[1], 'R', false);
      }
    }
  }
  function canvasPoint(evt){ var rect = state.canvas.getBoundingClientRect(); return { x:(evt.clientX-rect.left)*(state.canvas.width/rect.width), y:(evt.clientY-rect.top)*(state.canvas.height/rect.height) }; }
  function onPointerDown(e){
    if (!state.photo) return;
    if (state.calibrationActive) {
      e.preventDefault();
      if (state.calibrationReview) beginPupilReviewDrag(e);
      else handlePupilClick(e);
      return;
    }
    state.dragging = true; var p = canvasPoint(e); state.dragStart = {px:p.x, py:p.y, x:state.x, y:state.y}; try{state.canvas.setPointerCapture(e.pointerId);}catch(err){}
  }
  function onPointerMove(e){
    if (state.calibrationActive && state.calibrationReview && state.pupilDragActive) { e.preventDefault(); movePupilReviewDrag(e); return; }
    if (!state.dragging || !state.dragStart) return; var p = canvasPoint(e); state.x = state.dragStart.x + (p.x - state.dragStart.px); state.y = state.dragStart.y + (p.y - state.dragStart.py); requestDraw();
  }
  function onPointerUp(e){
    if (state.calibrationActive && state.calibrationReview && state.pupilDragActive) { e.preventDefault(); endPupilReviewDrag(e); return; }
    state.dragging = false; state.dragStart = null; try{state.canvas.releasePointerCapture(e.pointerId);}catch(err){}
  }

  function openCamera(){
    var modal = buildModal();
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { setStatus('Camera is unavailable in this browser. Please upload a photo instead.'); return; }
    setStatus('Opening camera...');
    navigator.mediaDevices.getUserMedia({ video:{ facingMode:'user', width:{ideal:1280}, height:{ideal:1280} }, audio:false })
      .then(function(stream){ state.stream = stream; state.video.srcObject = stream; qs('[data-es-tryon-clean-camera-panel]', modal).classList.add('is-active'); setStatus('Camera ready. Take a front-facing photo.'); })
      .catch(function(){ setStatus('Camera is unavailable or permission was blocked. Please upload a photo instead.'); });
  }
  function stopCamera(){
    var panel = state.modal && qs('[data-es-tryon-clean-camera-panel]', state.modal);
    if (panel) panel.classList.remove('is-active');
    if (state.stream) { state.stream.getTracks().forEach(function(t){ try{t.stop();}catch(err){} }); state.stream = null; }
    if (state.video) state.video.srcObject = null;
  }
  function captureCamera(){
    if (!state.video || !state.video.videoWidth) { setStatus('Camera is not ready yet.'); return; }
    var c = document.createElement('canvas'); c.width = state.video.videoWidth; c.height = state.video.videoHeight;
    c.getContext('2d').drawImage(state.video,0,0,c.width,c.height);
    var img = new Image();
    img.onload = function(){
      stopCamera();
      state.photoOriginal = img;
      state.photo = img;
      state.calibratedPupils = null;
      state.originalPupils = null;
      resetPupilMarkingState();
      persistTryOnSession();
      updateMarkButton();
      updatePupilReviewUI();
      setPupilStep(null);
      showPhotoMode('Preparing preview...');
      requestTryOnResizeAndDraw(function(){
        resetFrame();
        startPupilCalibration(false);
      });
    };
    img.src = c.toDataURL('image/jpeg',0.92);
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-es-tryon-open]');
    if (!btn) return;
    e.preventDefault();
    openTryOn(btn);
  });
})();
